import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SFAvatar,
  SFStack,
  SFPageContainer,
  getStyled,
  SFCard,
  SFCardBody,
  SFCardHeader,
  SFTypography,
  SFActionBar,
  ACTION_BAR_ACTION_TYPES,
  ACTION_BAR_ACTION_NAMES,
} from "@sf-core";
import { toastActions } from "@base-provider";
import { addUser } from "../../../services/userService";
import { useTranslation } from "react-i18next";
import NewUserForm from "./newUserForm";
import { useDispatch } from "react-redux";
import { PATHS } from "../../../constants/paths";

const { styled } = getStyled();

const SFAvatarStyled = styled(SFAvatar)(() => ({
  width: "164px",
  height: "164px",
  alignSelf: "center",
}));

const SFCardStyled = styled(SFCard)(() => ({
  overflow: "unset",
  border: "none",
}));

const NewUser = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    data: {
      name: "",
      email: "",
      userName: "",
      userRoleId: "",
      imageSrc: "",
    },
    errors: [],
  });

  const addUserHandler = useCallback(async () => {
    if (form.errors.length > 0) {
      dispatch(
        toastActions.showErrorMessage(
          t("usersScreen.messages.formValidationError")
        )
      );
      return;
    }

    const response = await addUser(form.data);
    const newUser = response.data;
    dispatch(
      toastActions.showSuccessMessage(t("usersScreen.messages.addSuccess"))
    );
    navigate(`/admin/users/${newUser.userId}`);
  }, [form.errors]);

  const onFormChange = (data, errors) => {
    setForm({ data, errors });
  };

  const leaveHandler = () => {
    navigate(PATHS.ADMIN_USERS);
  };

  const actionDefs = [
    {
      name: ACTION_BAR_ACTION_NAMES.CANCEL,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: () => leaveHandler(),
      buttonProps: {
        label: t("components.toolbar.templates.cancel"),
        variant: "secondary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.SAVE,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: addUserHandler,
      buttonProps: {
        label: t("components.toolbar.templates.save"),
        variant: "primary",
        async: true,
      },
    },
  ];

  return (
    <>
      <SFPageContainer disableGutters>
        <SFActionBar
          titleProps={{
            title: t("adminRoutes.newUser"),
          }}
          actionDefs={actionDefs}
        />
        <SFCardStyled>
          <SFCardHeader
            title={
              <SFTypography variant="cardSectionHeading">
                {t("usersScreen.newUserScreen.infoHeader")}
              </SFTypography>
            }
          />
          <SFCardBody>
            <SFStack direction="row" gap={5} alignItems="center">
              <SFAvatarStyled name={form.data.name} src={form.data.imageSrc} />
              <NewUserForm data={form.data} onChange={onFormChange} />
            </SFStack>
          </SFCardBody>
        </SFCardStyled>
      </SFPageContainer>
    </>
  );
};

export default NewUser;
